<template>
  <div class="ui-metro" v-if="metros.length">
    <ui-select
      v-model="currentId"
      :required="required"
      :label="label"
      :options="metros"
      empty-value="Не выбрана"
      placeholder="Выберите станцию метро"
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ui-metro',
  props: {
    value: {
      type: String,
      default: '',
    },
    emptyValue: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Станция метро',
    },
    cityId: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    metros: [],
  }),
  computed: {
    ...mapGetters({
      USER_CITY: 'user/city',
    }),
    currentId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    cityId() {
      this.$emit('input', '');
      this.metros = [];
      this.loadMetroSpecs();
    },
  },
  created() {
    if (this.$isServer) return;
    this.loadMetroSpecs();
  },
  methods: {
    loadMetroSpecs(cityId = this.cityId) {
      if (cityId === this.USER_CITY.id && !this.USER_CITY.hasMetro) return;
      return this.$store.$api.loadMetroStations({ cityId })
        .then(metros => {
          this.metros = metros.map(m => ({ name: m.name, value: m.id }));
        });
    },
  },
}
</script>

<style lang="scss">
.ui-metro {
  position: relative;
}
</style>